export const MARKET_URL = {
  ru: 'https://market.my.games/top_up/90/?lang=ru_US&utm_source=club.tacticool.game',
  en: 'https://market.my.games/top_up/90/?lang=en_US&utm_source=club.tacticool.game',
};

export const CLUB_PASS_MARKET_URL = {
  ru: 'https://market.my.games/shop/90/?lang=ru_RU%3Futm_source%3Dclub.tacticool.game&product_id=17354',
  en: 'https://market.my.games/shop/90/?lang=en_US%3Futm_source%3Dclub.tacticool.game&product_id=17354',
};
